export const change_password = {
  title: "Modifier le mot de passe",
  previous: "Ancien mot de passe",
  new: "Nouveau mot de passe",
  confirm: "Confirmation nouveau mot de passe",
  update: "Modifier",
  previous_password_error: "Ancien mot de passe incorrect!",
};
